import Image from "next/image";
import CTALink from "@/components/CTA/ctaLink";
import PromoBannerTooltip from "@/components/PromoBanner/components/PromoBannerTooltip";
import type { BasePromoBannerProps } from "@/components/PromoBanner/types";
import boldTextWithAsterisk from "@/utils/functions/boldTextWithAsterisk";

export default function PromoBannerSlim({
  className,
  cta,
  ctaElement,
  description,
  discount,
  discountCode,
  endDate,
  endDatePrefix = "Offer ends",
  image,
  learnMoreLink,
  title,
  useDefaultDiscountText = true,
  tooltip,
}: BasePromoBannerProps) {
  return (
    <div
      className={`flex flex-col md:flex-row bg-primary rounded-xl ${className || ""}`}
    >
      <div className="p-8 md:basis-3/5 xl:basis-3/4 xl:pr-64">
        <h2 className="text-primary-foreground italic mt-0 mb-4">{title}</h2>
        <p className="text-primary-foreground elm-p5 mb-4">
          {typeof description === "string"
            ? boldTextWithAsterisk(description)
            : description}{" "}
          {useDefaultDiscountText && !!discount && !!discountCode && (
            <>
              Get <strong>up to {discount} off</strong> with code{" "}
              <strong>{discountCode}</strong>.
            </>
          )}
        </p>
        {cta && !ctaElement && (
          <CTALink
            type="brand"
            size="xl"
            className="mb-4 w-full md:w-auto"
            label={cta.label}
            url={cta.url}
            location={cta.location}
            html_id={cta.html_id}
          />
        )}
        {ctaElement}
        {image?.url && image.height && image.width && (
          <Image
            src={image.url}
            alt={image.altText || ""}
            height={image.height}
            width={image.width}
            className="md:hidden mb-4"
          />
        )}
        <div className="flex gap-1 items-center">
          <p className="text-primary-foreground elm-p3 mb-0">
            {endDatePrefix} {endDate}.
          </p>
          <PromoBannerTooltip
            discountCode={discountCode}
            endDate={endDate}
            learnMoreLink={learnMoreLink}
            htmlContent={tooltip?.infoText ?? ""}
          />
        </div>
      </div>
      {image?.url && (
        <div className="hidden md:block relative clip-slant-left basis-2/5 xl:basis-1/4">
          <Image
            src={image.url}
            alt={image.altText || ""}
            className="object-cover rounded-r-xl"
            fill
          />
        </div>
      )}
    </div>
  );
}
